import { render, staticRenderFns } from "./PatientComp.vue?vue&type=template&id=18191a42&"
import script from "./PatientComp.vue?vue&type=script&lang=js&"
export * from "./PatientComp.vue?vue&type=script&lang=js&"
import style0 from "./PatientComp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports